import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Banner from './Components/banner';
import Branch from './Components/branches';
import Courses from './Components/courses';
import Enquiry from './Components/enquiry';
import Fullstack from './Components/fullstack';
import Help from './Components/help';
import Mobweb from './Components/mobweb';
import Navi from './Components/navi';
import Start from './Components/start';
import Techie from './Components/techie';
import whatsapp from './Images/whatsapp.png';
import MernStack from './Components/CourseDetails/MernStack';
import DataScience from './Components/CourseDetails/DataScience';
import PythonFullStack from './Components/CourseDetails/PythonFullStack';
import FullStackJava from './Components/CourseDetails/JavaFullStack';
import FullStackMobile from './Components/CourseDetails/MobileFullStack';
import FrontEndMobile from './Components/CourseDetails/MobileFrontEnd';
import MachineLearning from './Components/CourseDetails/MachineLearning';
import DataAnalytics from './Components/CourseDetails/DataAnalytics';
import { ScrollToTop, ScrollSpy } from './Components/ScrollControl';
import DigitalMarketing from './Components/CourseDetails/DigitalMarketing';
import { Helmet } from 'react-helmet';
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollSpy />
      <a href='https://wa.me/918667641134?text=Hii..' target='_blank'>
        <img src={whatsapp} className='n33' />
      </a>
      <Navi />
      <Routes>
        <Route path={"/"} element={
          <>
            <Helmet>
              <title>Full Stack & Data & Digital Marketing Courses | GT SOFTWARE ACADEMY</title>
              <meta
                name="description"
                content="GT SOFTWARE ACADEMY in Coimbatore offers professional training in Full Stack Development, Data Science, Machine Learning, Digital Marketing, and more. Learn from industry experts, work on real-time projects, and get placement support."
              />
              <meta
                name="keywords"
                content="Full Stack Development, Full Stack Web, Full Stack Mobile, Mobile Development, Front-End Development, Back-End Development, Database, React, Angular, Node, DotNet, Java, Python, MongoDB, MSSQL, Flutter, React Native, iOS Development, Android Development, Data Science, Pandas, Data Analytics, Power BI, SQL, Machine Learning Basics, Machine Learning, TensorFlow, Scikit-learn, Digital Marketing, GT SOFTWARE ACADEMY, Software Training, Training Institute, Coimbatore, India, Professional Courses, Hands-on Projects, Job-Ready Developer, Placement Assistance, Industry Experts, EMI Options, Nava India, Students, Professionals, Developers, Career in Software, Web Development Training, Mobile App Development Training"
              />
              <meta property="og:title" content="GT SOFTWARE ACADEMY in Coimbatore | Full Stack & Mobile Development Courses" />
              <meta property="og:description" content="Learn Full Stack, Mobile, Python, Java, Flutter, React Native, Data Science, and Digital Marketing courses at GT SOFTWARE ACADEMY, Coimbatore. Real-time projects, industry-relevant curriculum, and placement support." />
              <meta property="og:image" content="https://gtcollege.in/path-to-image/home-banner.PNG" />
              <meta property="og:type" content="website" />
              <meta name="robots" content="index, follow" />
              <link rel="canonical" href="https://gtcollege.in/" />
            </Helmet>
            <Banner />
            <Enquiry />
            <Techie />
            <Start />
            <Help />
            <Fullstack />
            <Branch />
          </>
        } />
        <Route path={"/info-ds"} element={<DataScience />} />
        <Route path={"/info-machine-learning"} element={<MachineLearning />} />
        <Route path={"/info-data-analytics"} element={<DataAnalytics />} />
        <Route path={"/info-python_full_stack"} element={<PythonFullStack />} />
        <Route path={"/info-java_full_stack"} element={<FullStackJava />} />
        <Route path={"/info-mobile_full_stack"} element={<FullStackMobile />} />
        <Route path={"/info-mobile_front_end"} element={<FrontEndMobile />} />
        <Route path={"/info-digital-marketing"} element={<DigitalMarketing />} />
        <Route path={"/info-mern"} element={<MernStack />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;